
export const initialValues = {
  baseUrl: "",
  menuName: "",
  sortOrderId: "",
  subMenuAvail: "",
  activeStatus: 1,

}